/** How recognised characters are shown and read aloud (shared by the pad and calibration). */
import type { Locale } from '@dropstack/core';
import type { HwChar } from '../contracts.ts';

/** Visible glyph: a real minus sign, and a decimal comma in Afrikaans (GAME_DESIGN.md § 12). */
export function displayChar(c: HwChar, locale: Locale): string {
  if (c === '-') return '−';
  if (c === '.') return locale === 'af' ? ',' : '.';
  return c;
}

/** Display a whole answer string the same way. */
export const displayText = (text: string, locale: Locale): string =>
  [...text].map((c) => (c === '-' ? '−' : c === '.' && locale === 'af' ? ',' : c)).join('');

/** 'hw' string key for characters a screen reader would otherwise mispronounce, or null for digits. */
export function spokenCharKey(c: HwChar): string | null {
  if (c === '-') return 'hw.charMinus';
  if (c === '/') return 'hw.charSlash';
  if (c === '.') return 'hw.charPoint';
  return null;
}
